import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  fetchFees,
  fetchFillsList,
  fetchFillsStats,
  fetchFillsUsers,
  updateFee,
} from "./client";

const root = ["hl", "fills"];
const feesKey = ["hl", "fees"];

export function useFillsStats(params) {
  return useQuery({
    queryKey: [...root, "stats", params],
    queryFn: () => fetchFillsStats(params),
  });
}

export function useFillsUsers(params) {
  return useQuery({
    queryKey: [...root, "users", params],
    queryFn: () => fetchFillsUsers(params),
    placeholderData: (prev) => prev,
  });
}

export function useFillsList(params) {
  return useQuery({
    queryKey: [...root, "list", params],
    queryFn: () => fetchFillsList(params),
    placeholderData: (prev) => prev,
  });
}

export function useFees() {
  return useQuery({
    queryKey: feesKey,
    queryFn: fetchFees,
  });
}

export function useUpdateFee() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ key, feeInt }) => updateFee(key, feeInt),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: feesKey }),
  });
}
